<div class="container">
    <div class="header">
        <div class="title">{{'workflow.workflow_settings' | stringLiterals}}</div>
        <div class="close">
            <smart-icon name="close" class="dialog-close light" (click)="onBtnClose()"></smart-icon>
        </div>
    </div>
    <div class="content">
        <div class="trigger-item">
            <div class="trigger-item-header">{{'general.trigger_method' | stringLiterals}}</div>
            <div class="trigger-method tam-form-field">
                <label tam-checkbox (click)="onCheckedChange()" class="item"
                    [(ngModel)]="workflowTriggerSettings.triggerMethod.manual" tid="manual_trigger">
                    <span class="caption">{{'general.manual_trigger' | stringLiterals}}</span>
                </label>
                <label tam-checkbox (click)="onCheckedChange()" class="item"
                    [(ngModel)]="workflowTriggerSettings.triggerMethod.scheduleJob" tid="scheduled_job_trigger">
                    <span class="caption">{{'general.schedule_job_trigger' | stringLiterals}}</span>
                </label>
                <label tam-checkbox (click)="onCheckedChange()" class="item"
                    [(ngModel)]="workflowTriggerSettings.triggerMethod.emailDeposit" tid="emial_deposit_trigger"
                    [disabled]="true">
                    <span class="caption">{{'general.email_deposit_trigger' | stringLiterals}}</span>
                </label>
                <label tam-checkbox (click)="onCheckedChange()" class="item"
                    [(ngModel)]="workflowTriggerSettings.triggerMethod.noteDeposit" tid="note_deposit_trigger">
                    <span class="caption">{{'general.note_deposit_trigger' | stringLiterals}}</span>
                </label>
                <label tam-checkbox (click)="onCheckedChange()" class="item"
                    [(ngModel)]="workflowTriggerSettings.triggerMethod.entityDeposit" tid="entity_deposit_trigger"
                    [disabled]="true">
                    <span class="caption">{{'general.entity_deposit_trigger' | stringLiterals}}</span>
                </label>
                <div class="tam-form-help" *ngIf="formErrorMsg.triggerMethodRequired">
                    {{'general.one_option_should_be_checked' | stringLiterals}}
                </div>
            </div>
        </div>
        <div class="trigger-item" [ngClass]="{'is-trigger-item-hidden':!isScheduledJobTrigger}">
            <div class="trigger-item-header">{{'general.schedule_job_trigger' | stringLiterals}}</div>
            <div class="scheduled-job-trigger">
                <div class="row item-sub-title">{{'general.recurrence' | stringLiterals}}</div>
                <div class="row control">
                    <div class="frequency" tid="frequency">
                        <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                            [data]="frequencyList" [textField]="'value'" [valueField]="'id'" [value]="selectedFrequency"
                            (valueChange)="onChangeFrequency($event)">
                        </kendo-dropdownlist>
                    </div>
                    <div class="wrapper" *ngIf="selectedFrequency.id!=='daily'">
                        <div class="sub-control">{{'general.on' | stringLiterals}}:</div>
                        <div class="on sub-control" *ngIf="selectedFrequency.id==='weekly'" tid="week_group">
                            <kendo-buttongroup [selection]="onWeeklyMode">
                                <button *ngFor="let item of onWeeklyList;index as i" kendoButton [toggleable]="true"
                                    [selected]="item.selected"
                                    (selectedChange)="onChangeOnWeekly($event,i)">{{item.value}}</button>
                            </kendo-buttongroup>
                        </div>
                        <div class="on sub-control" *ngIf="selectedFrequency.id==='monthly'">
                            <kendo-dropdownlist tid="on" [popupSettings]="{appendTo: 'component'}"
                                [ngStyle]="{'width':(selectedOnMonthly1.id==='day:L'?'100%':'')}" [filterable]="false"
                                [data]="onMonthlyList1" [textField]="'value'" [valueField]="'id'"
                                [value]="selectedOnMonthly1" (valueChange)="onChangeOnMonthly1($event)">
                            </kendo-dropdownlist>
                            <kendo-dropdownlist tid="weekday" [popupSettings]="{appendTo: 'component'}"
                                class="sub-control" *ngIf="selectedOnMonthly1.id!=='day:L'" [filterable]="false"
                                [data]="onMonthlyList2" [textField]="'value'" [valueField]="'id'"
                                [value]="selectedOnMonthly2" (valueChange)="onChangeOnMonthly2($event)">
                            </kendo-dropdownlist>
                        </div>
                        <div class="sub-control">{{'general.every' | stringLiterals}}:</div>
                        <div class="every sub-control" tid="every">
                            <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                                [data]="everyList" [textField]="'value'" [valueField]="'id'" [value]="selectedEvery"
                                (valueChange)="onChangeEvery($event)">
                            </kendo-dropdownlist>
                        </div>
                        <div class="sub-control">{{frequencyUnit}}</div>
                        <div class="sub-control" kendoTooltip
                            [title]="'Some months have fewer than '+selectedOnMonthly2.id+' days, For these months, Digest Email will not be sent, please use last day option.'"
                            *ngIf="emailDigest&&emailDigest.scheduler&&(emailDigest.scheduler.on==='day:29'||emailDigest.scheduler.on==='day:30'||emailDigest.scheduler.on==='day:31')">
                            <smart-icon name="info-o"></smart-icon>
                        </div>
                    </div>
                </div>
                <div class="row item-sub-title">{{'general.trigger_time' | stringLiterals}}</div>
                <div class="row control time" tid="trigger_time">
                    <kendo-timepicker [steps]="timesteps" [format]="'hh:mm a'" [value]="time"
                        (valueChange)="onChangeTime($event)"></kendo-timepicker>
                </div>
                <div class="row item-sub-title">{{'general.start_date' | stringLiterals}}</div>
                <div class="row control" tid="start_date">
                    <kendo-datepicker calendarType="classic" [value]="startDate"
                        (valueChange)="onChangeStartDate($event)">
                    </kendo-datepicker>
                </div>
                <div class="row item-sub-title">{{'general.time_zone' | stringLiterals}}:</div>
                <div class="row control time-zone">
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" [filterable]="false"
                        [data]="timezoneList" [textField]="'name'" [valueField]="'id'" [value]="selectedTimezone"
                        (valueChange)="onChangeTimezone($event)">
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>
        <div class="trigger-item" [ngClass]="{'is-trigger-item-hidden':!isScheduledJobTrigger}">
            <div class="trigger-item-header">{{'general.kick_off_by_entities' | stringLiterals}}</div>
            <div class="kick-off-multiple-project-by-entities tam-form-field">
                <div class="checkbox-row" tid="entity_type_checkbox">
                    <label tam-checkbox class="item" [(ngModel)]="isEntityTypeChecked"
                        (click)="onEntityTypeCheckedChange()">{{'general.entity_type_is' |
                        stringLiterals}}&nbsp;</label>
                    <tam-single-select-dropdown-filter [dropdownConfig]="entityTypeConfig">
                        <ng-template #customContent>
                            <div class="selected-item">
                                <a (click)="onSelectEntityTypeClick($event)">{{entityType}}</a>
                            </div>
                        </ng-template>
                    </tam-single-select-dropdown-filter>
                </div>
                <div class="checkbox-row" tid="relationship_checkbox">
                    <label tam-checkbox class="item" [(ngModel)]="isRelationshipChecked"
                        (click)="onRelationshipCheckedChange()">{{'general.relationship_is' |
                        stringLiterals}}&nbsp;</label>
                    <tam-single-select-dropdown-filter [dropdownConfig]="relationshipTypeConfig">
                        <ng-template #customContent>
                            <div class="selected-item">
                                <a (click)="onSelectRelationshipTypeClick($event)">{{relationshipType}}</a>
                            </div>
                        </ng-template>
                    </tam-single-select-dropdown-filter>
                    &nbsp;{{'general.parent_entity_is' | stringLiterals}}&nbsp;
                    <tam-single-entity-dropdown-filter [config]="entityConfig">
                        <ng-template #customContent>
                            <div class="selected-item">
                                <a (click)="onSelectEntityClick($event)">{{entity}}</a>
                            </div>
                        </ng-template>
                    </tam-single-entity-dropdown-filter>
                </div>
                <div class="tam-form-help" *ngIf="formErrorMsg.entityTypeRequired || formErrorMsg.relationshipRequired">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
        </div>
        <div class="trigger-item"
            [ngClass]="{'is-trigger-item-hidden':!workflowTriggerSettings.triggerMethod.noteDeposit}">
            <tam-note-deposit-trigger [noteDepositEntityTypeConfig]="noteDepositEntityTypeConfig"
                [triggerSource]="noteTriggerSource"></tam-note-deposit-trigger>
            <div class="tam-form-help" *ngIf="formErrorMsg.noteTriggerRequired">
                {{'general.required_error_message' | stringLiterals}}
            </div>
        </div>
        <div class="trigger-item tam-form-field" attr.tid="{{projectTriggerCons.ProjectName}}">
            <div class="trigger-item-header">
                <div class="project">
                    <field-label [label]="projectTriggerCons.ProjectName"
                        [tooltip]="projectTriggerCons.Project_Name_Tooltip" isRequired=True></field-label>
                </div>
            </div>
            <input type="text" class="tam-textbox project-name" [(ngModel)]="definitionSetting.projectName.name"
                (blur)="onProjectNameBlur()">
            <div class="tam-form-help" *ngIf="formErrorMsg.projectNameRequired">
                {{'general.required_error_message' | stringLiterals}}
            </div>
        </div>
        <div class="trigger-item tam-form-field">
            <div class="trigger-item-header">{{'workflow.primary_entity' | stringLiterals}}</div>
            <kendo-combobox #primary_entity [popupSettings]="{appendTo: 'component'}"
                class="primary-entity-textbox field-control" [filterable]="true" [data]="entityItems"
                [textField]="'fieldDefEntityName'" [valueField]="'fieldDefId'"
                [(ngModel)]="definitionSetting.primaryEntity" (filterChange)="filterAdhocEntityValue($event)"
                (focus)="onPrimaryyEntityDropdownFocus($event)">
            </kendo-combobox>
        </div>
    </div>
    <div class="footer">
        <div class="operation-box">
            <button class="footer-button" tam-button (click)="onBtnClose()" [tamType]="'tertiary'"
                [tamSize]="'normal'">{{'general.cancel' | stringLiterals}}</button>
            <button class="footer-button" tam-button (click)="onBtnSave()" [tamType]="'primary'"
                [tamSize]="'normal'">{{'general.save' | stringLiterals}}</button>
        </div>
    </div>
</div>